import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import infoIcon from "Assets/newicons/notify/info/outline/info-outline-16px.svg";
import Tooltip from "@material-ui/core/Tooltip";
import DynamicForm, {
  fetchMyForm,
} from "../../../../../../Component/DynamicForm";
import { integerinputconverter } from "../../../../../../Component/DynamicForm/Fields/Integer";
import { selectinputconverter } from "../../../../../../Component/DynamicForm/Fields/Select";
import KEYS from "../../../../../../Component/DynamicForm/KEYS";

const LIMITS = [
  { displayvalue: 1, displayname: "Monthly Limit" },
  { displayvalue: 2, displayname: "Weekly Limit" },
  { displayvalue: 3, displayname: "Daily Limit" },
];

function getOptArr({ arr, displaynamekey, displayvaluekey, optional }) {
  console.log("value: ", optional);
  console.log("displayvaluekey: ", displayvaluekey);
  console.log("displaynamekey: ", displaynamekey);
  console.log("arr: ", arr);
  return arr.map((element) => ({
    ...element,
    displayname: element[displaynamekey],
    displayvalue: element[displayvaluekey],
  }));
}

const initfieldvalue = [{ valuename: "", subexpensefieldvalueid: "" }];

function outputconverter(fields) {
  const getFV = (x) => {
    const v = x.value;
    const fv =
      x.fieldvalue &&
      x.fieldvalue.map((ff) => {
        const o =
          v &&
          v.find(
            (obj) => obj.subexpensefieldvalueid == ff.subexpensefieldvalueid,
          );
        if (o) {
          ff.isselected = true;
        }
        return ff;
      });
    return fv;
  };
  return fields.map((field) => ({
    ...field,
    fieldvalue: getFV(field),
    value:
      field.fielddatatypid === KEYS.Select
        ? field.value
          .map((f) => {
            f.isselected = true;
            return f;
          })
          .filter(
            (val) =>
              field.value.findIndex(
                (v) =>
                  v.subexpensefieldvalueid === val.subexpensefieldvalueid,
              ) !== -1,
          ) // value = { displayvalue, displayname }
        : field.typeid === KEYS.Select
          ? field.fieldvalue.filter(
            (val) =>
              get(field, "value.subexpensefieldvalueid", "") ===
              val.subexpensefieldvalueid,
          )
          : field.fieldvalue[0] // present if editing, else in creating
            ? field.fieldvalue.map((val) => ({ ...val, valuename: field.value }))
            : initfieldvalue.map((val) => ({ ...val, valuename: field.value })),
  }));
}

function inputconverter(fields) {
  // console.log('fields: ', fields);
  // const tempvalue = fields.find(x => {x.fieldvalue && x.fieldvalue.map( x1 =>{x1.subexpensefieldvalueid == 0})})
  return fields
    ? fields.map((field) => ({
      ...field,
      typeid:
        field.fielddatatypid == KEYS.Select
          ? KEYS.MultiSelect
          : field.fielddatatypid,
      value:
        field.fielddatatypid === KEYS.Select // here select is consider as multiselect
          ? getOptArr({
            arr: get(field, "fieldvalue", []).filter(
              (opt) => opt.isselected,
            ),
            displaynamekey: "valuename",
            displayvaluekey: "subexpensefieldvalueid",
            optional: "yups",
          })
          : get(field, `fieldvalue[0].valuename`, []),
      id: field.subexpensefieldid,
      required: field.isrequired,
      options:
        field.fielddatatypid === KEYS.Select ||
          field.fielddatatypid === KEYS.MultiSelect
          ? getOptArr({
            arr: get(field, "fieldvalue", []),
            displaynamekey: "valuename",
            displayvaluekey: "subexpensefieldvalueid",
          })
          : null,
      validation: /^^/,
      error: false,
      iserr: ({ fielddata }) => {
        let flag = false;
        if (fielddata.required) {
          if (
            fielddata.fielddatatypid == 6 ||
            fielddata.fielddatatypid == 11
          ) {
            flag = fielddata.value.length == 0;
          } else {
            flag = !fielddata.value;
          }
        }
        if (fielddata.defaultfieldtypeid == 2 && fielddata.value) {
          flag = fielddata.value > fielddata.categorylimit;
        }
        return flag;
      },
      helperText:
        field.defaultfieldtypeid == 2
          ? `must be less than ${field.categorylimit}`
          : "",
      errorText:
        field.defaultfieldtypeid == 2
          ? `must be less than ${field.categorylimit}`
          : "Please fill required field",
      placeholder: `Enter ${field.fieldname}`,
      label: field.fieldname,
    }))
    : [];
}

class details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 2,
      selectedPolicy: props.selectedPolicy,
    };
    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
    });

    // selectedPolicy1.push(
    //   ...this.state.selectedPolicy,
    // );
  }

  handleChange(name, index, e) {
    const { selectedPolicy } = this.state;
    if (name == "isexceptionallowed" && !index && index != 0) {
      selectedPolicy[name] = !selectedPolicy[name];
    } else if (name == "isexceptionallowed") {
      selectedPolicy.category[index][name] = !selectedPolicy.category[index][
        name
      ];
    } else if (name == "policylimit") {
      if (parseInt(index) < 1) {
        selectedPolicy[name] = "";
      } else {
        selectedPolicy[name] = index;
      }
    } else if (name == "categorylimittypeid") {
      selectedPolicy.category[index][name] = e;
    } else if (name == "categorylimit") {
      if (parseInt(e) > 0) {
        if (parseInt(e) > parseInt(selectedPolicy.policylimit)) {
          // selectedPolicy.category[index][name] = selectedPolicy.policylimit;
          this.props.enqueueSnackbar(
            "Category limit cannot be greater than policy limit",
            { variant: "error" },
          );
          selectedPolicy.category[index][name] = "";
          this.setState({
            selectedPolicy,
          });
          return;
        } else {
          selectedPolicy.category[index][name] = e;
        }
      } else {
        selectedPolicy.category[index][name] = "";
      }
    }

    this.setState({
      selectedPolicy,
    });
  }

  onSubmit = () => {
    this.props.onRef({
      onNext: this.onSubmit,
    });
    const { selectedPolicy } = this.state;
    let isvalid = true;

    selectedPolicy.category &&
      selectedPolicy.category.forEach((category) => {
        if (category.categorylimit == "" || category.categorylimit == null) {
          isvalid = false;
        } else if (
          category.categorylimittypeid == null ||
          category.categorylimittypeid == ""
        ) {
          isvalid = false;
        } else if (
          parseInt(category.categorylimit) >
          parseInt(selectedPolicy.policylimit)
        ) {
          isvalid = false;
        }
      });
    let c = true;
    if (isvalid) {
      selectedPolicy.category = selectedPolicy.category.map((category) => {
        category.subcategory = category.subcategory.map((subcategory) => {
          const form = fetchMyForm(subcategory.subexpensesubcategoryid);
          form &&
            form.fields.forEach((field) => {
              if (field.iserr({ fielddata: field }) === true) {
                // this.props.enqueueSnackbar(field.errorText, {
                //   variant: "error",
                // });
                isvalid = false;
              }
            });
          if (isvalid) {
            subcategory.field = outputconverter(get(form, "fields", null));
            isvalid = true;
          } else {
            isvalid = false;
          }
          return subcategory;
        });
        return category;
      });
    } else {
      this.props.enqueueSnackbar("Please fill required fields", {
        variant: "error",
      });
      c = false;
    }
    if (!selectedPolicy.policylimit) {
      this.props.enqueueSnackbar("Please enter policy limit", {
        variant: "error",
      });
    } else if (isvalid) {
      // console.log("selectedPolicy: ", selectedPolicy);
      this.setState({
        selectedPolicy,
      });
      this.props.onNextClick(selectedPolicy);
    } else if (c) {
      // this.props.enqueueSnackbar("Please fill correct required fields", {
      //   variant: "error",
      // });
      this.props.enqueueSnackbar("Please fill required fields", {
        variant: "error",
      });
    }
  };

  render() {
    const { selectedPolicy } = this.state;
    // console.log('selectedPolicy: ', selectedPolicy);
    this.state.selectedPolicy &&
      this.state.selectedPolicy &&
      this.state.selectedPolicy.category &&
      this.state.selectedPolicy.category.map((x, catindex) => {
        x.subcategory &&
          x.subcategory.map((x1, index1) => {
            // console.log('index1: ', index1);
            // console.log(' x1.field: ', x1.field);
            x1.field &&
              x1.field &&
              x1.field.map((x2) => {
                x2.fieldvalue &&
                  !x2.fieldvalue.find((y) => y.subexpensefieldvalueid == 0) &&
                  x2.fieldvalue.unshift({
                    expensepolicyfieldvalueid: 0,
                    fuelfieldtypeid: null,
                    fueltypeid: null,
                    isfuelconfig: false,
                    isselected: false,
                    subexpensefieldvalueid: 0,
                    valuename: "All",
                  });
              });
          });
      });
    return (
      <Grid container className="set-limit-outer thin-scroll">
        <Grid item xs={12} md={12} sm={12}>
          <div>
            <p className="sub-heading">
              <span>
                Assign monthly expense limit to
                <strong> {selectedPolicy && selectedPolicy.policyname} </strong>
                Policy
              </span>
            </p>
            <TextField
              className="expense-cycle-input"
              id="outlined-dense"
              margin="dense"
              variant="outlined"
              type="number"
              placeholder={
                this.props.SubscriptionInfo.SubscriptionData.currencycode
              }
              value={selectedPolicy && selectedPolicy.policylimit}
              onChange={(e) => this.handleChange("policylimit", e.target.value)}
            />
            <span style={{ marginLeft: 8, marginTop: 8 }}>
              {this.props.SubscriptionInfo.SubscriptionData.currencycode}{" "}
            </span>
          </div>
          <div
            className="display-flex"
            style={{ alignItems: "center", marginTop: 8 }}
          >
            <Switch
              checked={
                selectedPolicy && selectedPolicy.isexceptionallowed
                  ? true
                  : false
              }
              onChange={() => this.handleChange("isexceptionallowed")}
              value={
                selectedPolicy && selectedPolicy.isexceptionallowed
                  ? true
                  : false
              }
              // name={column}
              color="primary"
            />

            <div className="display-flex" style={{ alignItems: "center" }}>
              <p className="small-dark-secondary margin-right-16">
                Allow employee to request for expense exceeding their limit
              </p>
              <Tooltip
                title="If you allow employees to request expenses exceeding their limit, employees' expense claims will be appended with an Alert which notifies the approvers about that particular claim being over-limit."
                placement="right"
              >
                <p className="small-dark-secondary">ℹ️</p>
              </Tooltip>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={12} sm={12} style={{ marginTop: 12 }}>
          <p className="sub-heading">
            Assign expense limits to your categories
          </p>
          {selectedPolicy &&
            selectedPolicy.category &&
            selectedPolicy.category.map((category, catindex) => (
              // const selectedLimit = null;
              // if (category.categorylimittypeid) {
              //   selectedLimit = LIMITS.find((limit) => limit.displayvalue == category.categorylimittypeid);
              // }
              <div key={`trail${catindex}`} className="expense-limit-outer">
                <div className="category-name-wrapper">
                  <span className="category-name">{category.categoryname}</span>
                </div>
                <div style={{ marginTop: -24, marginBottom: 16 }}>
                  <span className="floatleft margin-right-16 width40">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: category.categorylimittypeid,
                        placeholder: "Select limit",
                        options: LIMITS,
                      })}
                      formKey="categorylimittypeid"
                      onChange={(value) =>
                        this.handleChange(
                          "categorylimittypeid",
                          catindex,
                          value,
                        )
                      }
                    />
                  </span>
                  <span className="floatleft width40">
                    <DynamicForm
                      fields={integerinputconverter({
                        value: category.categorylimit,
                        placeholder: this.props.SubscriptionInfo
                          .SubscriptionData.currencycode,
                      })}
                      formKey="categorylimit"
                      onChange={(value) =>
                        this.handleChange("categorylimit", catindex, value)
                      }
                    />
                  </span>
                  <span style={{ marginLeft: 8, marginTop: 8 }}>
                    {this.props.SubscriptionInfo.SubscriptionData.currencycode}{" "}
                  </span>
                </div>
                {category.subcategory &&
                  category.subcategory.map((subcategory, index) => (
                    <div
                      key={`subcat${index}`}
                      className="expense-subcategory-list clear-float"
                    >
                      <div className="subcategory">
                        <div className="margin-bottom-16">
                          {/* <span className="expense-subcategory-icon">
                            <img src={flightIcon} alt="" height="20" />
                          </span> */}
                          <span className="expense-subcategory-name">
                            {subcategory.subcategoryname}
                          </span>
                          <DynamicForm
                            fields={inputconverter(subcategory.field)}
                            formKey={subcategory.subexpensesubcategoryid}
                            categorylimit={category.categorylimit || 0}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                <div className="form-group clear-float">
                  <div className="expense-limit-switch">
                    <Switch
                      checked={category.isexceptionallowed ? true : false}
                      onChange={() =>
                        this.handleChange("isexceptionallowed", catindex)
                      }
                      value={category.isexceptionallowed ? true : false}
                      // name={column}
                      color="primary"
                    />
                  </div>
                  <div className="floatleft margin-top-16">
                    <p className="sub-heading">
                      <FormattedMessage
                        id="#"
                        defaultMessage="Allow employee to request for expense exceeding their limit "
                      />
                    </p>
                  </div>
                </div>
              </div>
            ))}
        </Grid>
      </Grid>
    );
  }
}
const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(details));
